import { Injectable } from '@angular/core';
import { getUserRole } from 'src/app/utils/util';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor() {}

  // tslint:disable-next-line:typedef
  async getUser() {
    const u = {};
    return { ...u, role: getUserRole() };
  }
}
